import Arrow from './Arrow.vue'

export default Arrow
